export default {"src":"/_next/static/media/Openly.36908f71.svg","height":45,"width":71};